export const BUSINESS_WORKFLOW_STATE_STATUS_MAPPING = {
	synced: { title: 'فعال', variant: 'success' },
	rejected: { title: 'غیر فعال', variant: 'disabled' },
	spam: { title: 'غیر فعال', variant: 'disabled' },
	new: { title: 'در انتظار تایید', variant: 'warning' },
	signed: { title: 'در انتظار تایید', variant: 'warning' },
	assigned: { title: 'در انتظار تایید', variant: 'warning' },
	completed: { title: 'در انتظار تایید', variant: 'warning' },
	incompleted: { title: 'در انتظار تایید', variant: 'warning' },
	approved: { title: 'در انتظار تایید', variant: 'warning' },
};
